export const opportunityUnsubscribePath = "/unsubscribe/creator-visit-emails";
export const isOpportunityUnsubscribePath = (path: string) => path.startsWith(opportunityUnsubscribePath);

// Imported before app/analytics initialization. Keep the bearer token only in memory.
let initialToken = "";
try {
  const tokenWindow = window as Window & { __shrpaOpportunityUnsubscribeToken?: string };
  initialToken = tokenWindow.__shrpaOpportunityUnsubscribeToken ?? "";
  delete tokenWindow.__shrpaOpportunityUnsubscribeToken;
  if (isOpportunityUnsubscribePath(window.location.pathname)) {
    const url = new URL(window.location.href);
    initialToken = initialToken || new URLSearchParams(url.hash.slice(1)).get("token") || url.searchParams.get("token") || "";
    url.hash = "";
    url.searchParams.delete("token");
    window.history.replaceState(window.history.state, "", url.pathname + url.search);
    const referrer = document.createElement("meta");
    referrer.name = "referrer";
    referrer.content = "no-referrer";
    document.head.appendChild(referrer);
  }
} catch {
  // Preserve any captured token and let startup continue. Never log unsubscribe credentials.
}

export function takeOpportunityUnsubscribeToken(): string {
  const token = initialToken;
  initialToken = "";
  return token;
}
